import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/system/role/role';
import waves from '@/directive/waves'; // 水波纹指令

import roleAdd from './add';
import allotAuthorize from './allotAuthorize';
import allotMember from './allotMember';
export default {
  name: 'ComplexTable',
  components: {
    roleAdd: roleAdd,
    allotAuthorize: allotAuthorize,
    allotMember: allotMember
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        roleName: '',
        entSerno: ''
      },
      title: '',
      roleId: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogAllotFormVisible: false,
      dialogMemberFormVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogAllotFormVisible = false;
      this.dialogMemberFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 配置菜单
    handleallotAuthorize: function handleallotAuthorize(roleId) {
      this.roleId = roleId;
      this.dialogAllotFormVisible = true;
    },
    // 配置人员
    handleallotMember: function handleallotMember(roleId) {
      this.roleId = roleId;
      this.dialogMemberFormVisible = true;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.roleId = -1;
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(roleId) {
      this.roleId = roleId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    deletes: function deletes(roleIds) {
      var _this2 = this;

      if (roleIds.length > 0) {
        this.$confirm('你确定是要删除这些角色, 是否继续?', '提示').then(function () {
          fetchDelete(roleIds).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(roleId) {
      var roleIds = [];
      roleIds.push(roleId);
      this.deletes(roleIds);
    },
    handleDeletes: function handleDeletes() {
      var roleIds = [];
      this.multipleSelection.forEach(function (row) {
        roleIds.push(row.roleId);
      });
      this.deletes(roleIds);
    },
    isHideButton: function isHideButton(isSuper) {
      if (isSuper === null) {
        return false;
      } else {
        if (isSuper === 1) {
          return false;
        } else {
          return true;
        }
      }
    },
    selected: function selected(row, index) {
      console.log(row, 'row');

      if (row.isSuper == 1) {
        // 根据你的条件来设置
        return false; //可选择
      } else {
        return true; //不可选择
      }
    }
  }
};